export function sellersPropertyDisclosureLand2026() {
return [   // Release 2025-12-20 15:04:12
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date SPD completed by Seller", 
   fontSize: 9,
   type: "date",
   top: 533.64,
   left: 168.0,
   width: 381.0,
   height: 13.353
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 551.64,
   left: 80.16,
   width: 468.84,
   height: 13.353
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 569.64,
   left: 69.12,
   width: 479.88,
   height: 13.353
}
,
{
   page: 0,
   name: "Listing Year Built", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 587.64,
   left: 167.28,
   width: 381.72,
   height: 13.353
}
,
{
   page: 1,
   name: "Checkbox FloodingProblemsEverExisting Flooding", 
   isText: false,
   type: "checkbox",
   top: 122.524,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 1,
   name: "FloodingProblemsEverExisting Flooding", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 116.28,
   left: 190.56,
   width: 402.12,
   height: 81.48
}
,
{
   page: 1,
   name: "Checkbox FloodingProblemsEverExisting Drainage issues", 
   isText: false,
   type: "checkbox",
   top: 205.808,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 1,
   name: "FloodingProblemsEverExisting Drainage issues", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.56,
   left: 190.56,
   width: 402.12,
   height: 71.16
}
,
{
   page: 1,
   name: "Checkbox FloodingProblemsEverExisting Grading issues", 
   isText: false,
   type: "checkbox",
   top: 277.081,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 1,
   name: "FloodingProblemsEverExisting Grading issues", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 272.52,
   left: 191.215,
   width: 402.120,
   height: 81.48
}
,
{
   page: 1,
   name: "FloodingProblemsEverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.8,
   left: 42,
   width: 118.68,
   height: 40.2
}
,
{
   page: 1,
   name: "Checkbox FloodingProblemsEverExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 359.564,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 1,
   name: "FloodingProblemsEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.8,
   left: 190.56,
   width: 402.12,
   height: 40.2
}
,
{
   page: 1,
   name: "Checkbox Drainage or rentention ponds", 
   isText: false,
   type: "checkbox",
   top: 470.076,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 1,
   name: "Drainage or retention ponds", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 466.2,
   left: 190.56,
   width: 402.12,
   height: 81.48
}
,
{
   page: 1,
   name: "Drainage Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 549.48,
   left: 42,
   width: 118.68,
   height: 50.52
}
,
{
   page: 1,
   name: "Checkbox Drainage Extra Row", 
   isText: false,
   type: "checkbox",
   top: 552.56,
   left: 168.17,
   width: 13.68,
   height: 13.68
}
,
{
   page: 1,
   name: "Drainage Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 549.48,
   left: 190.56,
   width: 402.12,
   height: 50.52
}
,
{
   page: 1,
   name: "Checkbox SOW Public", 
   isText: false,
   type: "checkbox",
   top: 634.243,
   left: 124.126,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Checkbox SOW Community", 
   isText: false,
   type: "checkbox",
   top: 634.243,
   left: 168.971,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Checkbox SOW Well", 
   isText: false,
   type: "checkbox",
   top: 635.043,
   left: 231.435,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Checkbox SOW Shared Well", 
   isText: false,
   type: "checkbox",
   top: 634.243,
   left: 272.276,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Checkbox SOW Public Other", 
   isText: false,
   type: "checkbox",
   top: 634.243,
   left: 340.345,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Checkbox SOW None", 
   isText: false,
   type: "checkbox",
   top: 634.243,
   left: 381.987,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Radiobutton WellPermitProvided Is", 
   isText: false,
   type: "checkbox",
   top: 649.458,
   left: 264.268,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Radiobutton WellPermitProvided Is Not", 
   isText: false,
   type: "checkbox",
   top: 649.458,
   left: 295.354,
   width: 13.025,
   height: 13.680
}
,
{
   page: 1,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 645.051,
   left: 433.56,
   width: 157.44,
   height: 14.709
}
,
{
   page: 1,
   name: "Radiobutton DrillingRecordsProvided Are", 
   isText: false,
   type: "checkbox",
   top: 665.474,
   left: 107.163,
   width: 13.025,
   height: 13.680
}
,
{
   page: 1,
   name: "Radiobutton DrillingRecordsProvided Are Not", 
   isText: false,
   type: "checkbox",
   top: 665.474,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Radiobutton SharedWellAgreement Yes", 
   isText: false,
   type: "checkbox",
   top: 664.673,
   left: 330.735,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "Radiobutton SharedWellAgreement No", 
   isText: false,
   type: "checkbox",
   top: 664.673,
   left: 366.772,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "SOURCE OF WATER  WATER SUPPLY", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.004,
   left: 38.0946,
   width: 555.2404,
   height: 30.3528
}
,
{
   page: 2,
   name: "Checkbox Zoning violation or variance", 
   isText: false,
   type: "checkbox",
   top: 113.715,
   left: 173.776,
   width: 13.680,
   height: 14.335
}
,
{
   page: 2,
   name: "Zoning violation or variance", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 109.56,
   left: 194.88,
   width: 397.80,
   height: 63.00
}
,
{
   page: 2,
   name: "Checkbox Notice or threat of condemnation proceedings", 
   isText: false,
   type: "checkbox",
   top: 178.581,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Notice or threat of condemnation proceedings", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 174.36,
   left: 194.88,
   width: 397.80,
   height: 63.24
}
,
{
   page: 2,
   name: "Checkbox Notice of adverse conditions from governmental agency", 
   isText: false,
   type: "checkbox",
   top: 242.646,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Notice of adverse conditions from governmental agency", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 239.4,
   left: 194.88,
   width: 397.80,
   height: 55.32
}
,
{
   page: 2,
   name: "Checkbox Notice of zoning action related to the Property", 
   isText: false,
   type: "checkbox",
   top: 301.105,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Notice of zoning action related to the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 296.52,
   left: 194.88,
   width: 397.80,
   height: 63.00
}
,
{
   page: 2,
   name: "Checkbox Building code city or county violations", 
   isText: false,
   type: "checkbox",
   top: 365.971,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Building code city or county violations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 361.32,
   left: 194.88,
   width: 397.80,
   height: 53.88
}
,
{
   page: 2,
   name: "Checkbox Violation of restrictive covenants or owners association rules or regulations", 
   isText: false,
   type: "checkbox",
   top: 420.426,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Violation of restrictive covenants or owners association rules or regulations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 417,
   left: 194.88,
   width: 397.80,
   height: 53.88
}
,
{
   page: 2,
   name: "Checkbox Other legal action", 
   isText: false,
   type: "checkbox",
   top: 475.682,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Other legal action", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 472.68,
   left: 194.88,
   width: 397.80,
   height: 53.88
}
,
{
   page: 2,
   name: "Checkbox Any part of the Property leased to others", 
   isText: false,
   type: "checkbox",
   top: 530.938,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Any part of the Property leased to others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 528.36,
   left: 194.88,
   width: 397.80,
   height: 44.76
}
,
{
   page: 2,
   name: "Checkbox Archeological or historical designation on the Property", 
   isText: false,
   type: "checkbox",
   top: 577.385,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Archeological or historical designation on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 574.92,
   left: 194.88,
   width: 397.80,
   height: 44.76
}
,
{
   page: 2,
   name: "Checkbox Threatened or Endangered species on the Property", 
   isText: false,
   type: "checkbox",
   top: 623.832,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Threatened or Endangered species on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.48,
   left: 194.88,
   width: 397.80,
   height: 44.76
}
,
{
   page: 2,
   name: "Checkbox Grandfathered conditions or uses", 
   isText: false,
   type: "checkbox",
   top: 671.881,
   left: 173.776,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Grandfathered conditions or uses", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.04,
   left: 194.88,
   width: 397.80,
   height: 44.52
}
,
{
   page: 2,
   name: "Zoning Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 713.36,
   left: 37.44,
   width: 127.80,
   height: 35.64
}
,
{
   page: 2,
   name: "Checkbox Zoning Extra Row", 
   isText: false,
   type: "checkbox",
   top: 716.7261,
   left: 173.776,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 2,
   name: "Zoning Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 714.36,
   left: 194.88,
   width: 397.80,
   height: 35.64
}
,
{
   page: 3,
   name: "Checkbox Any access problems issues or concerns", 
   isText: false,
   type: "checkbox",
   top: 103.305,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Any access problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 99.24,
   left: 190.56,
   width: 402.12,
   height: 72.12
}
,
{
   page: 3,
   name: "Checkbox Roads trails paths or driveways through the Property used by others", 
   isText: false,
   type: "checkbox",
   top: 176.979,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Roads trails paths or driveways through the Property used by others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 173.16,
   left: 190.56,
   width: 402.12,
   height: 81.48
}
,
{
   page: 3,
   name: "Checkbox Public highway or county road bordering the Property", 
   isText: false,
   type: "checkbox",
   top: 261.064,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Public highway or county road bordering the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 256.44,
   left: 190.56,
   width: 402.12,
   height: 72.36
}
,
{
   page: 3,
   name: "Checkbox Any proposed or existing transportation project", 
   isText: false,
   type: "checkbox",
   top: 335.54,
   left: 168.17,
   width: 13.68,
   height: 13.68
}
,
{
   page: 3,
   name: "Any proposed or existing transportation project", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.6,
   left: 190.56,
   width: 402.12,
   height: 72.36
}
,
{
   page: 3,
   name: "Checkbox Encroachments boundary disputes or unrecorded easements", 
   isText: false,
   type: "checkbox",
   top: 407.613,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Encroachments boundary disputes or unrecorded easements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 404.76,
   left: 190.56,
   width: 402.12,
   height: 63.00
}
,
{
   page: 3,
   name: "Checkbox Shared or common areas with adjoining properties", 
   isText: false,
   type: "checkbox",
   top: 474.08,
   left: 168.17,
   width: 13.68,
   height: 13.68
}
,
{
   page: 3,
   name: "Shared or common areas with adjoining properties", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.56,
   left: 190.56,
   width: 402.12,
   height: 63.24
}
,
{
   page: 3,
   name: "Checkbox Requirements for curb gravelpaving landscaping", 
   isText: false,
   type: "checkbox",
   top: 538.145,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Requirements for curb gravelpaving landscaping", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.6,
   left: 190.56,
   width: 402.12,
   height: 63.0
}
,
{
   page: 3,
   name: "Checkbox Any limitations on parking or access due to size number of vehicles or type of vehicles in the past year", 
   isText: false,
   type: "checkbox",
   top: 603.011,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Any limitations on parking or access due to size number of vehicles or type of vehicles in the past year", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 599.4,
   left: 190.56,
   width: 402.12,
   height: 63.24
}
,
{
   page: 3,
   name: "Access Extra Row 1 Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.44,
   left: 37.44,
   width: 123.24,
   height: 44.52
}
,
{
   page: 3,
   name: "Checkbox Access Extra Row 1", 
   isText: false,
   type: "checkbox",
   top: 667.076,
   left: 168.17,
   width: 13.68,
   height: 13.680
}
,
{
   page: 3,
   name: "Access Extra Row 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.44,
   left: 190.56,
   width: 402.12,
   height: 44.52
}
,
{
   page: 3,
   name: "Access Extra Row 2 Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 710.76,
   left: 37.44,
   width: 123.24,
   height: 35.64
}
,
{
   page: 3,
   name: "Checkbox Access Extra Row 2", 
   isText: false,
   type: "checkbox",
   top: 713.5229,
   left: 168.17,
   width: 13.68,
   height: 13.6800
}
,
{
   page: 3,
   name: "Access Extra Row 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 710.76,
   left: 190.56,
   width: 402.12,
   height: 35.64
}
,
{
   page: 4,
   name: "Checkbox Hazardous materials on the Property", 
   isText: false,
   type: "checkbox",
   top: 118.52,
   left: 177.78,
   width: 13.68,
   height: 13.68
}
,
{
   page: 4,
   name: "Hazardous materials on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 113.4,
   left: 199.44,
   width: 388.68,
   height: 77.16
}
,
{
   page: 4,
   name: "Checkbox Underground storage tanks", 
   isText: false,
   type: "checkbox",
   top: 195.398,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Underground storage tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 192.36,
   left: 199.44,
   width: 388.68,
   height: 44.76
}
,
{
   page: 4,
   name: "Checkbox Aboveground storage tanks", 
   isText: false,
   type: "checkbox",
   top: 242.646,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Aboveground storage tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 238.92,
   left: 199.44,
   width: 388.68,
   height: 44.52
}
,
{
   page: 4,
   name: "Checkbox Underground transmission lines", 
   isText: false,
   type: "checkbox",
   top: 290.694,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Underground transmission lines", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 285.24,
   left: 199.44,
   width: 388.68,
   height: 53.88
}
,
{
   page: 4,
   name: "Checkbox Property used as situated on or adjoining a dump", 
   isText: false,
   type: "checkbox",
   top: 344.349,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Property used as situated on or adjoining a dump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 340.92,
   left: 199.44,
   width: 388.68,
   height: 53.88
}
,
{
   page: 4,
   name: "Checkbox Monitoring wells or test equipment", 
   isText: false,
   type: "checkbox",
   top: 400.406,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Monitoring wells or test equipment", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 396.6,
   left: 199.44,
   width: 388.68,
   height: 54.12
}
,
{
   page: 4,
   name: "Checkbox Sliding settling upheaval movement or instability of earth or expansive soils", 
   isText: false,
   type: "checkbox",
   top: 457.263,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Sliding settling upheaval movement or instability of earth or expansive soils", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 452.52,
   left: 199.44,
   width: 388.68,
   height: 53.88
}
,
{
   page: 4,
   name: "Checkbox Mine shafts tunnels or abandoned wells", 
   isText: false,
   type: "checkbox",
   top: 510.117,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Mine shafts tunnels or abandoned wells", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 508.2,
   left: 199.44,
   width: 388.68,
   height: 53.88
}
,
{
   page: 4,
   name: "Checkbox Within a governmentally designated geological hazard", 
   isText: false,
   type: "checkbox",
   top: 566.174,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Within a governmentally designated geological hazard", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 563.88,
   left: 199.44,
   width: 388.68,
   height: 53.88
}
,
{
   page: 4,
   name: "Checkbox Within a governmentally designated floodplain or wetland area", 
   isText: false,
   type: "checkbox",
   top: 623.031,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Within a governmentally designated floodplain or wetland area", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 619.56,
   left: 199.44,
   width: 388.68,
   height: 53.88
}
,
{
   page: 4,
   name: "Checkbox Dead diseased or infested trees or shrubs", 
   isText: false,
   type: "checkbox",
   top: 677.486,
   left: 177.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Dead diseased or infested trees or shrubs", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 675.24,
   left: 199.44,
   width: 388.68,
   height: 72.36
}
,
{
   page: 5,
   name: "Checkbox Environmental assessments studies or reports done involving the physical condition of the Property", 
   isText: false,
   type: "checkbox",
   top: 49.65,
   left: 176.179,
   width: 13.680,
   height: 13.68
}
,
{
   page: 5,
   name: "Environmental assessments studies or reports done involving the physical condition of the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 45.36,
   left: 200.228,
   width: 386.807,
   height: 45.12
}
,
{
   page: 5,
   name: "Checkbox Used for any mining graveling or other natural resource extraction operations such as oil and gas wells", 
   isText: false,
   type: "checkbox",
   top: 95.297,
   left: 176.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Used for any mining graveling or other natural resource extraction operations such as oil and gas wells", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 91.92,
   left: 200.228,
   width: 386.807,
   height: 45.12
}
,
{
   page: 5,
   name: "Checkbox Other environmental problems issues or concerns", 
   isText: false,
   type: "checkbox",
   top: 141.744,
   left: 176.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Other environmental problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 138.48,
   left: 200.228,
   width: 386.807,
   height: 45.12
}
,
{
   page: 5,
   name: "Checkbox Odors", 
   isText: false,
   type: "checkbox",
   top: 188.191,
   left: 176.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Odors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 185.04,
   left: 200.228,
   width: 386.807,
   height: 44.88
}
,
{
   page: 5,
   name: "Checkbox Environment Extra Row Title", 
   isText: false,
   type: "checkbox",
   top: 234.638,
   left: 176.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Environment Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 231.72,
   left: 37.44,
   width: 132.36,
   height: 35.64
}
,
{
   page: 5,
   name: "Environment Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 233.329,
   left: 200.259,
   width: 386.900,
   height: 31.627
}
,
{
   page: 5,
   name: "Checkbox HOA Owners association", 
   isText: false,
   type: "checkbox",
   top: 354.759,
   left: 181.983,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "HOA Owners association", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 350.695,
   left: 204.0,
   width: 384.12,
   height: 63.000
}
,
{
   page: 5,
   name: "Checkbox HOA Special assessments", 
   isText: false,
   type: "checkbox",
   top: 418.824,
   left: 181.983,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "HOA Special assessments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.84,
   left: 204,
   width: 384.12,
   height: 53.88
}
,
{
   page: 5,
   name: "Checkbox HOA Defects", 
   isText: false,
   type: "checkbox",
   top: 476.483,
   left: 181.983,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "HOA Defects", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 470.52,
   left: 204,
   width: 384.12,
   height: 53.88
}
,
{
   page: 5,
   name: "Checkbox HOA_EverExisting Lawsuit", 
   isText: false,
   type: "checkbox",
   top: 605.413,
   left: 181.983,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "HOA_EverExisting Lawsuit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 597.96,
   left: 204,
   width: 384.12,
   height: 107.64
}
,
{
   page: 5,
   name: "HOA_EverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 707.4,
   left: 37.44,
   width: 136.68,
   height: 35.64
}
,
{
   page: 5,
   name: "Checkbox HOA_EverExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 715.1245,
   left: 181.983,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 5,
   name: "HOA_EverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 707.4,
   left: 204,
   width: 384.12,
   height: 35.64
}
,
{
   page: 6,
   name: "Checkbox Contact InformationOwners Association 1", 
   isText: false,
   type: "checkbox",
   top: 119.321,
   left: 182.585,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Contact InformationOwners Association 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 114.36,
   left: 204,
   width: 384.12,
   height: 39.96
}
,
{
   page: 6,
   name: "Checkbox Contact InformationOwners Association 2", 
   isText: false,
   type: "checkbox",
   top: 160.162,
   left: 182.585,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Contact InformationOwners Association 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 156.12,
   left: 204,
   width: 384.12,
   height: 40.20
}
,
{
   page: 6,
   name: "Checkbox Contact InformationOwners Association 3", 
   isText: false,
   type: "checkbox",
   top: 201.004,
   left: 182.585,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Contact InformationOwners Association 3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 197.88,
   left: 203.76,
   width: 384.60,
   height: 26.52
}
,
{
   page: 6,
   name: "Checkbox Contact InformationOwners Association 4", 
   isText: false,
   type: "checkbox",
   top: 229.032,
   left: 182.585,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Contact InformationOwners Association 4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 225.84,
   left: 203.64,
   width: 384.84,
   height: 23.28
}
,
{
   page: 6,
   name: "Checkbox GeneralEverExisting Reports of any issues", 
   isText: false,
   type: "checkbox",
   top: 309.113,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "GeneralEverExisting Reports of any issues", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 306.84,
   left: 204,
   width: 388.68,
   height: 55.32
}
,
{
   page: 6,
   name: "Checkbox Property insurance claim submitted", 
   isText: false,
   type: "checkbox",
   top: 368.373,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Property insurance claim submitted", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 363.96,
   left: 204,
   width: 388.68,
   height: 50.52
}
,
{
   page: 6,
   name: "Checkbox Government special improvements approved", 
   isText: false,
   type: "checkbox",
   top: 421.227,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Government special improvements approved", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 416.28,
   left: 204,
   width: 388.68,
   height: 66.12
}
,
{
   page: 6,
   name: "Checkbox Pending litigation or other dispute", 
   isText: false,
   type: "checkbox",
   top: 488.495,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Pending litigation or other dispute", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 484.2,
   left: 204,
   width: 388.68,
   height: 40.2
}
,
{
   page: 6,
   name: "Checkbox Signs Government or private restriction", 
   isText: false,
   type: "checkbox",
   top: 530.938,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Signs Government or private restriction", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 526.2,
   left: 204,
   width: 388.68,
   height: 40.2
}
,
{
   page: 6,
   name: "Checkbox Subject to Deed Restrictions", 
   isText: false,
   type: "checkbox",
   top: 572.58,
   left: 181.386,
   width: 13.680,
   height: 13.68
}
,
{
   page: 6,
   name: "Subject to Deed Restrictions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 568.2,
   left: 204,
   width: 388.68,
   height: 47.64
}
,
{
   page: 6,
   name: "General Disclosures Ever Existing Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 617.52,
   left: 37.2,
   width: 137.16,
   height: 29.28
}
,
{
   page: 6,
   name: "Checkbox General Disclosures Ever Existing Extra Row", 
   isText: false,
   type: "checkbox",
   top: 620.629,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "General Disclosures Ever Existing Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 617.52,
   left: 203.76,
   width: 389.16,
   height: 29.28
}
,
{
   page: 6,
   name: "Checkbox General Other Information", 
   isText: false,
   type: "checkbox",
   top: 650.259,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "General Other Information1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 648.48,
   left: 203.4,
   width: 389.88,
   height: 17.04
}
,
{
   page: 6,
   name: "General Other Information Title 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 667.32,
   left: 37.44,
   width: 136.68,
   height: 39.96
}
,
{
   page: 6,
   name: "Checkbox General Other Information 2", 
   isText: false,
   type: "checkbox",
   top: 670.279,
   left: 181.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "General Other Information2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 667.32,
   left: 204,
   width: 388.68,
   height: 39.96
}
,
{
   page: 7,
   name: "Checkbox Crops being grown on the Property", 
   isText: false,
   type: "checkbox",
   top: 110.512,
   left: 185.788,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Crops being grown on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 103.08,
   left: 208.56,
   width: 384.12,
   height: 71.16
}
,
{
   page: 7,
   name: "Checkbox Seller owns all crops", 
   isText: false,
   type: "checkbox",
   top: 178.581,
   left: 185.788,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Seller owns all crops", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 176.04,
   left: 208.56,
   width: 384.12,
   height: 60.84
}
,
{
   page: 7,
   name: "Checkbox Livestock on the Property", 
   isText: false,
   type: "checkbox",
   top: 241.845,
   left: 185.788,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Livestock on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 238.68,
   left: 208.56,
   width: 384.12,
   height: 71.16
}
,
{
   page: 7,
   name: "Checkbox LandLeasedFromOthers State", 
   isText: false,
   type: "checkbox",
   top: 324.528,
   left: 41.3643,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedFromOthers BLM", 
   isText: false,
   type: "checkbox",
   top: 325.129,
   left: 89.2885,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedFromOthers Federal", 
   isText: false,
   type: "checkbox",
   top: 336.54,
   left: 41.3643,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedFromOthers Private", 
   isText: false,
   type: "checkbox",
   top: 335.938,
   left: 89.2885,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedFromOthers Other", 
   isText: false,
   type: "checkbox",
   top: 348.552,
   left: 41.3643,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "LandLeasedFromOthers Other Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 346.44,
   left: 79.08,
   width: 99.502,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox Land leased from others", 
   isText: false,
   type: "checkbox",
   top: 315.52,
   left: 185.788,
   width: 13.680,
   height: 13.68
}
,
{
   page: 7,
   name: "Land leased from others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 311.64,
   left: 208.56,
   width: 384.12,
   height: 68.28
}
,
{
   page: 7,
   name: "Checkbox LandLeasedToOthers State", 
   isText: false,
   type: "checkbox",
   top: 394.999,
   left: 41.3643,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedToOthers BLM", 
   isText: false,
   type: "checkbox",
   top: 394.999,
   left: 88.4876,
   width: 10.4836,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedToOthers Federal", 
   isText: false,
   type: "checkbox",
   top: 406.41,
   left: 41.3643,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedToOthers Private", 
   isText: false,
   type: "checkbox",
   top: 406.41,
   left: 88.4876,
   width: 10.4836,
   height: 10.483
}
,
{
   page: 7,
   name: "Checkbox LandLeasedToOthers Other", 
   isText: false,
   type: "checkbox",
   top: 417.824,
   left: 41.3643,
   width: 10.4835,
   height: 10.483
}
,
{
   page: 7,
   name: "LandLeasedToOthers Other Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 416.52,
   left: 79.08,
   width: 99.502,
   height: 10.483
}
,
{
   page: 7,
   name: "Checbox Land leased to others", 
   isText: false,
   type: "checkbox",
   top: 385.19,
   left: 185.788,
   width: 13.680,
   height: 13.68
}
,
{
   page: 7,
   name: "Land leased to others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 381.72,
   left: 208.56,
   width: 384.12,
   height: 68.28
}
,
{
   page: 7,
   name: "Crops Livestock Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.68,
   left: 37.2,
   width: 141.72,
   height: 29.28
}
,
{
   page: 7,
   name: "Crops Livestock Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.025,
   left: 208.32,
   width: 384.60,
   height: 29.280
}
,
{
   page: 7,
   name: "Noxious weeds", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 540.36,
   left: 208.56,
   width: 384.12,
   height: 71.16
}
,
{
   page: 7,
   name: "Weed enforcement actions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.32,
   left: 208.56,
   width: 384.12,
   height: 60.84
}
,
{
   page: 7,
   name: "Noxious weed management plan entered into", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 675.305,
   left: 208.56,
   width: 384.12,
   height: 60.8405
}
,
{
   page: 7,
   name: "Checkbox Crops Livestock Extra Row", 
   isText: false,
   type: "checkbox",
   top: 455.662,
   left: 185.788,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Checkbox Noxious weeds", 
   isText: false,
   type: "checkbox",
   top: 544.552,
   left: 184.187,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Checkbox Weed enforcement actions", 
   isText: false,
   type: "checkbox",
   top: 617.426,
   left: 184.187,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Checkbox Noxious weed management plan entered into", 
   isText: false,
   type: "checkbox",
   top: 679.889,
   left: 184.187,
   width: 13.680,
   height: 13.6798
}
,
{
   page: 8,
   name: "Checkbox Noxious weed management plan implemented", 
   isText: false,
   type: "checkbox",
   top: 48.849,
   left: 183.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Noxious weed management plan implemented", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 45.6,
   left: 209.593,
   width: 383.119,
   height: 60.96
}
,
{
   page: 8,
   name: "Checkbox Herbicides applied", 
   isText: false,
   type: "checkbox",
   top: 112.114,
   left: 183.386,
   width: 13.680,
   height: 13.025
}
,
{
   page: 8,
   name: "Herbicides applied", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 108.24,
   left: 209.593,
   width: 383.119,
   height: 60.96
}
,
{
   page: 8,
   name: "Noxious Weeds Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171,
   left: 37.44,
   width: 136.68,
   height: 40.2
}
,
{
   page: 8,
   name: "Checkbox Noxious Weeds Extra Row", 
   isText: false,
   type: "checkbox",
   top: 172.174,
   left: 183.386,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Noxious Weeds Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 172.415,
   left: 209.593,
   width: 383.119,
   height: 36.025
}
,
{
   page: 8,
   name: "Checkbox Enrolled governmental programs", 
   isText: false,
   type: "checkbox",
   top: 338.743,
   left: 163.366,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Enrolled governmental programs", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 334.92,
   left: 186,
   width: 402.12,
   height: 66.36
}
,
{
   page: 8,
   name: "Checkbox Conservation easement", 
   isText: false,
   type: "checkbox",
   top: 406.011,
   left: 163.366,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Conservation easement", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.08,
   left: 186,
   width: 402.12,
   height: 50.52
}
,
{
   page: 8,
   name: "Land Conservation Extra Row 1 Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.4,
   left: 37.44,
   width: 118.68,
   height: 50.28
}
,
{
   page: 8,
   name: "Checkbox Land Conservation Extra Row 1", 
   isText: false,
   type: "checkbox",
   top: 458.865,
   left: 163.366,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Land Conservation Extra Row 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 456.055,
   left: 186.0,
   width: 402.12,
   height: 50.280
}
,
{
   page: 8,
   name: "Land Conservation Extra Row 2 Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507.48,
   left: 37.44,
   width: 118.68,
   height: 40.20
}
,
{
   page: 8,
   name: "Checkbox Land Conservation Extra Row 2", 
   isText: false,
   type: "checkbox",
   top: 510.918,
   left: 163.366,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Land Conservation Extra Row 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507.48,
   left: 186,
   width: 402.12,
   height: 40.20
}
,
{
   page: 8,
   name: "Seller 1 Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 6,
   top: 608.96,
   left: 54.2276,
   width: 372.7324,
   height: 20.278
}
,
{
   page: 8,
   name: "Seller 2 Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 6,
   top: 649.12,
   left: 54.2276,
   width: 372.7324,
   height: 20.278
}
,
{
   page: 8,
   name: "Seller 3 Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 6,
   top: 690.64,
   left: 54.2276,
   width: 372.7324,
   height: 20.2776
}
,
{
   page: 8,
   name: "Seller 4 Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 6,
   top: 731.92,
   left: 54.2276,
   width: 372.7324,
   height: 20.2776
}
] }
